module.exports = __webpack_public_path__ + "img/va.2cb971ef.svg";